<style>
  .app-version {
    position: absolute;
    bottom: 0;
    right: 10px;
    font-size: 75%;
  }
</style>

<template>
  <div>
    <div class="header">
      <div class="row">
        <div class="small-12 columns">
          <span class="tab-message show-for-medium">Edit your assumptions</span>
        </div>
      </div>
    </div>

    <section>
      <div class="tabs-content">
        <div class="tabs-panel is-active">
          <div class="row">
            <div class="small-12 medium-4 columns">
              <label>Wage inflation p.a.</label>
            </div>

            <div class="medium-5 large-6 columns">
              <slider :percent="true" :property="WageInflation" @update="actionWageInflation({ value: $event.values[0] })"></slider>
            </div>

            <div class="small-12 medium-3 large-2 columns">
              <custom-input type="number" :percent="true" filter="percent" :property="WageInflation" @change="actionWageInflation({ value: $event.target.value })"></custom-input>
            </div>
          </div>

          <div class="row">
            <div class="small-12 medium-4 columns">
              <label>Price inflation p.a.</label>
            </div>

            <div class="medium-5 large-6 columns">
              <slider :percent="true" :property="PriceInflation" @update="actionPriceInflation({ value: $event.values[0] })"></slider>
            </div>

            <div class="small-12 medium-3 large-2 columns">
              <custom-input type="number" :percent="true" filter="percent" :property="PriceInflation" @change="actionPriceInflation({ value: $event.target.value })"></custom-input>
            </div>
          </div>

          <div class="row">
            <div class="small-12 medium-4 columns">
              <div>
                <label>
                  <span v-if="this.includePartner && !this.OverrideFundDefaultInsurancePremiums.value">Your </span>
                  Insurance Premium p.a.
                  <help-icon message="The default amount(s) shown are based on QSuper’s insurance arrangements; refer to the Limitations and Assumptions for details. If you enter a custom insurance premium, the amount entered will be applied for both you and your partner (if applicable) individually."></help-icon>
                </label>
              </div>
              <div v-if="this.includePartner && !this.OverrideFundDefaultInsurancePremiums.value" class="mt-2">
                <label>Partner's Insurance Premium p.a.</label>
              </div>
            </div>

            <div>
              <div class="medium-5 large-6 columns">
                <slider :property="InsurancePremium" @update="actionInsurancePremium({ value: $event.values[0] })"></slider>
              </div>

              <div class="small-12 medium-3 large-2 columns">
                <custom-input
                  v-if="this.OverrideFundDefaultInsurancePremiums.value == true"
                  type="number"
                  filter="currencyDisplay2"
                  :property="InsurancePremium"
                  @update="actionInsurancePremium({ value: $event.target.value })"
                ></custom-input>

                <div v-if="!this.OverrideFundDefaultInsurancePremiums.value">
                  <div :data-formatted="'Default - $' + this.fundDefaultInsurancePremiumFirstYear" v-if="this.OverrideFundDefaultInsurancePremiums.value == false" class="custom-input custom-input-hide">
                    <input type="number" class="vs-input" disabled>
                  </div>

                  <div :data-formatted="'Default - $' + this.partnerFundDefaultInsurancePremiumFirstYear" v-if="this.includePartner && this.OverrideFundDefaultInsurancePremiums.value == false" class="custom-input custom-input-hide mt-1">
                    <input type="number" class="vs-input" disabled>
                  </div>
                </div>

                <button
                  class="btn-link"
                  v-if="this.OverrideFundDefaultInsurancePremiums.value == true"
                  @click="actionOverwriteDefaultInsuranceTable({ value: false })"
                >
                  Reset
                </button>

                <button
                  class="btn-link"
                  v-if="this.OverrideFundDefaultInsurancePremiums.value == false"
                  @click="actionOverwriteDefaultInsuranceTable({ value: true })"
                >
                  Use custom amount
                </button>
              </div>
            </div>
          </div>

          <!-- <div
            class="row"
            :class="this.inferred.UserSpecifiedDBAccrualRates.value > 0 ? '' : 'disable'"
            v-if="this.inferred.DefinedBenefit.value > 0 || this.inferred.DefinedBenefit_2.value > 0"
          >
            <div class="small-12 medium-4 columns">
              <label>Defined Benefit Multiple Growth p.a.</label>
            </div>

            <div class="medium-5 large-6 columns">
              <slider
                :property="UserSpecifiedDBAccrualRates"
                @update="actionUserSpecifiedDBAccrualRates({ value: $event.values[0] })"
              ></slider>
            </div>

            <div class="small-12 medium-3 large-2 columns">
              <custom-input
                type="number"
                :property="UserSpecifiedDBAccrualRates"
                @update="actionUserSpecifiedDBAccrualRates({ value: $event.target.value })"
              ></custom-input>
            </div>
          </div>

          <hr /> -->

          <div class="row">
            <div class="small-12 medium-12 columns">
              <h2 class="section-sub-heading">Custom investment return</h2>
            </div>
          </div>

          <div class="row">
            <div class="small-12 medium-4 columns">
              <label>Use calculator defaults</label>
            </div>

            <div class="medium-5 large-6 columns"></div>

            <div class="small-12 medium-3 large-2 columns">
              <select @change="prefillCustomInvestment($event.target.value - 1)">
                <option :value="option.id" :key="option.id" v-for="option in InvestmentOptions" :selected="CustomOption === option.id - 1">{{ option.name }}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="small-12 medium-4 columns">
              <label>Custom Return before taxes and fees p.a.</label>
            </div>

            <div class="medium-5 large-6 columns">
              <slider :percent="true" :property="GrossReturn" @update="setGrossReturn($event.values[0])"></slider>
            </div>

            <div class="small-12 medium-3 large-2 columns">
              <custom-input type="number" :percent="true" filter="percent" :property="GrossReturn" @update="setGrossReturn($event.target.value)"></custom-input>
            </div>
          </div>


          <div class="row boxed">
            <div class="small-12 medium-4 columns">
              <label>Fee charged on balances p.a. (fee cap applies)</label>
            </div>

            <div class="medium-5 large-6 columns">
              <slider :percent="true" :property="FeePercentageOnBalanceCapped" @update="actionFeePercentageOnBalanceCapped({ value: $event.values[0] })"></slider>
            </div>

            <div class="small-12 medium-3 large-2 columns">
              <custom-input type="number" :percent="true" filter="percent" :property="FeePercentageOnBalanceCapped" @update="actionFeePercentageOnBalanceCapped({ value: $event.target.value })"></custom-input>
            </div>
          </div>

          <div class="row boxed">
            <div class="small-12 medium-4 columns">
              <label>Capped at ($)</label>
            </div>

            <div class="medium-5 large-6 columns">
              <slider :property="FeePercentageOnBalanceCappedCap" @update="actionFeePercentageOnBalanceCappedCap({ value: $event.values[0] })"></slider>
            </div>

            <div class="small-12 medium-3 large-2 columns">
              <custom-input type="number" filter="currencyDisplay2" :property="FeePercentageOnBalanceCappedCap" @update="actionFeePercentageOnBalanceCappedCap({ value: $event.target.value })"></custom-input>
            </div>
          </div>


          <div class="row">
            <div class="small-12 medium-4 columns">
              <label>Fee charged on balances p.a. (no fee cap)</label>
            </div>

            <div class="medium-5 large-6 columns">
              <slider :percent="true" :property="FeePercentageOnBalance" @update="actionFeePercentageOnBalance({ value: $event.values[0] })"></slider>
            </div>

            <div class="small-12 medium-3 large-2 columns">
              <custom-input type="number" :percent="true" filter="percent" :property="FeePercentageOnBalance" @update="actionFeePercentageOnBalance({ value: $event.target.value })"></custom-input>
            </div>
          </div>

          <div class="row">
            <div class="small-12 medium-4 columns">
              <label>Fees charged on contributions p.a.</label>
            </div>

            <div class="medium-5 large-6 columns">
              <slider :percent="true" :property="FeePercentageOnContributions" @update="actionFeePercentageOnContributions({ value: $event.values[0] })"></slider>
            </div>

            <div class="small-12 medium-3 large-2 columns">
              <custom-input type="number" :percent="true" filter="percent" :property="FeePercentageOnContributions" @update="actionFeePercentageOnContributions({ value: $event.target.value })"></custom-input>
            </div>
          </div>

          <div class="row">
            <div class="small-12 medium-4 columns">
              <label>Annual dollar based fee</label>
            </div>

            <div class="medium-5 large-6 columns">
              <slider :property="FeeAnnualDollar" @update="actionFeeAnnualDollar({ value: $event.values[0] })"></slider>
            </div>

            <div class="small-12 medium-3 large-2 columns">
              <custom-input type="number" filter="currencyDisplay2" :property="FeeAnnualDollar" @update="actionFeeAnnualDollar({ value: $event.target.value })"></custom-input>
            </div>
          </div>

          <span class="app-version">{{ env.value.NODE_ENV }}-{{ env.value.VERSION }}</span>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
// import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import { findInvestmentOptions, calculateClosestTaxableIncome } from '@/store/helpers';
import { Constants } from '@/constants';

export default {
  computed: {
    ...mapState(['inferred', 'env', 'inputs', 'results']),

    InvestmentOptions() {
      return findInvestmentOptions([]).sortBy(i => i.id).value();
    },
    CustomOption() {
      return this.inferred.CustomOption.value;
    },
    WageInflation() {
      return this.inferred.WageInflation;
    },
    PriceInflation() {
      return this.inferred.PriceInflation;
    },
    GrossReturn() {
      return this.inferred.GrossReturn;
    },
    FeePercentageOnBalance() {
      return this.inferred.FeePercentageOnBalance;
    },
    FeePercentageOnBalanceCapped() {
      return this.inferred.FeePercentageOnBalanceCapped;
    },
    FeePercentageOnBalanceCappedCap() {
      return this.inferred.FeePercentageOnBalanceCappedCap;
    },
    FeePercentageOnContributions() {
      return this.inferred.FeePercentageOnContributions;
    },
    FeeAnnualDollar() {
      return this.inferred.FeeAnnualDollar;
    },
    OverrideFundDefaultInsurancePremiums() {
      return this.inferred.OverrideFundDefaultInsurancePremiums;
    },
    InsurancePremium() {
      return this.inferred.InsurancePremium;
    },
    UserSpecifiedDBAccrualRates() {
      return this.inferred.UserSpecifiedDBAccrualRates;
    },

    includePartner() {
      return this.inputs.IncludePartner.value;
    },
    fundDefaultInsurancePremiumFirstYear() {
      const val = Math.round(this.results.engineResults.subjectOutput.insuranceFees[0]);
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(val)) {
        return 0;
      }
      return this.formatDollars(val);
    },
    partnerFundDefaultInsurancePremiumFirstYear() {
      const val = Math.round(this.results.engineResults.partnerOutput.insuranceFees[0]);
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(val)) {
        return 0;
      }
      return this.formatDollars(val);
    },
  },

  watch: {
    UserSpecifiedDBAccrualRates: {
      handler(newValue) {
        this.setUseSpecificDBAccrualRates(newValue);
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions([
      'actionWageInflation',
      'actionPriceInflation',
      'actionCustomOption',
      'actionGrossReturn',
      'actionTaxableFraction',
      'actionFeePercentageOnBalance',
      'actionFeePercentageOnBalanceCapped',
      'actionFeePercentageOnBalanceCappedCap',
      'actionFeePercentageOnContributions',
      'actionFeeAnnualDollar',
      'actionInsurancePremium',
      'actionOverwriteDefaultInsuranceTable',
      'actionUserSpecifiedDBAccrualRates',
      'actionUseSpecificDBAccrualRates',
    ]),

    formatDollars(val) {
      return (`${val}`).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    prefillCustomInvestment(key) {
      this.setGrossReturn(this.InvestmentOptions[key].grossReturn * 100);
      this.actionFeePercentageOnBalance({ value: 0 });
      this.actionFeePercentageOnBalanceCapped({ value: this.InvestmentOptions[key].feePercentageOnBalanceCapped * 100 });
      this.actionFeePercentageOnBalanceCappedCap({ value: this.InvestmentOptions[key].feePercentageOnBalanceCappedCap });
      this.actionFeePercentageOnContributions({ value: 0 });
      this.actionFeeAnnualDollar({ value: this.InvestmentOptions[key].feeAnnualDollar });
      // this.actionInsurancePremium({ value: this.inferred.InsurancePremium.value });
      this.actionUserSpecifiedDBAccrualRates({ value: 0 });
      this.actionUseSpecificDBAccrualRates({ value: false });
      this.actionCustomOption({ value: key });
    },

    setGrossReturn(value) {
      let payloadValue = 0;
      if (value < Constants.MIN_CUSTOM_INVESTMENT_VALUE) {
        payloadValue = Constants.MIN_CUSTOM_INVESTMENT_VALUE;
      } else if (value > Constants.MAX_CUSTOM_INVESTMENT_VALUE) {
        payloadValue = Constants.MAX_CUSTOM_INVESTMENT_VALUE;
      } else {
        payloadValue = Math.round(value * 100000) / 100000;
      }
      // this.actionTaxableFraction({ value: this.getTaxableFraction(value / 100) });
      const investmentOptionsList = findInvestmentOptions([]).sortBy(i => i.id).value();
      if (value < investmentOptionsList[0].grossReturn * 100) {
        this.actionTaxableFraction({ value: investmentOptionsList[0].taxableFraction }); // if return is lower than the lowest config, use the lowest taxable fraction
      } else {
        this.actionTaxableFraction({ value: calculateClosestTaxableIncome(payloadValue / 100) }); // using the helper class calculateClosestTaxableIncome
      }
      this.actionGrossReturn({ value: payloadValue });
    },

    // Similar to lifetime getTaxable // lifetime#model.js.coffee#553
    // getTaxableFraction(grossReturn) {
    //   const min = this.findGrossReturn('min', grossReturn);
    //   const max = this.findGrossReturn('max', grossReturn);

    //   const grossReturnRounded = Math.round(grossReturn * 10000) / 10000;
    //   const gross = (grossReturnRounded - min.grossReturn) / (max.grossReturn - min.grossReturn);
    //   const taxable = min.taxableFraction - max.taxableFraction;

    //   return min.taxableFraction - (gross * taxable);
    // },

    // findGrossReturn(type, boundary) {
    //   const investments = this.InvestmentOptions;
    //   const lowest = _.first(investments);
    //   const highest = _.last(investments);

    //   const findMin = type === 'min';
    //   const findMax = !findMin;

    //   // No point in searching because we've sorted and the lowest is first and latest last.
    //   if (findMin && !boundary) return lowest;
    //   if (findMax && !boundary) return highest;

    //   let foundBoundary = false;
    //   let returnedInvestment = findMin ? lowest : highest;

    //   _.each(investments, (option) => {
    //     if (findMin && option.grossReturn > returnedInvestment.grossReturn && option.grossReturn < boundary) {
    //       returnedInvestment = option;
    //     }

    //     if (findMax && option.grossReturn < returnedInvestment.grossReturn && option.grossReturn > boundary && !foundBoundary) {
    //       returnedInvestment = option;
    //       foundBoundary = true;
    //     }
    //   });

    //   return returnedInvestment;
    // },

    setUseSpecificDBAccrualRates(newValue) {
      if (newValue.value > 0) {
        this.actionUseSpecificDBAccrualRates({ value: true });
      } else {
        this.actionUseSpecificDBAccrualRates({ value: false });
      }
    },

  },
};
</script>
